import React from 'react';

const FIELDS = [['address_line1', 'Street address', true], ['address_line2', 'Apt, suite or unit', false], ['city', 'City', true], ['state', 'State', true], ['zip_code', 'Zip code', true]];

export const HcSsrAddress = ({ address, setAddress, confirmed, setConfirmed, field }) => (
  <div className="space-y-3 border-t border-gray-100 pt-4" data-testid="hc-ssr-address-section">
    <div>
      <h3 className="font-bold text-[#363636]">Mailing address</h3>
      <p className="text-sm text-gray-500">This is the address on your profile. Update it here if it has changed.</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-3">
      {FIELDS.map(([key, text, req]) => (
        <div key={key} className={key.startsWith('address') ? 'sm:col-span-2' : ''}>
          <label className="text-sm font-semibold text-[#363636]">{text}{req && <span className="text-red-600"> *</span>}</label>
          <input value={address[key] || ''} required={req} maxLength={200} onChange={(e) => { setAddress({ ...address, [key]: e.target.value }); setConfirmed(false); }}
            className={field} data-testid={`hc-ssr-address-${key}`} />
        </div>
      ))}
    </div>
    <label className="flex items-start gap-3 cursor-pointer" data-testid="hc-ssr-address-confirm-label">
      <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} className="mt-1 w-5 h-5 accent-[#922A8C]" data-testid="hc-ssr-address-confirm" />
      <span className="text-sm text-[#363636]">I confirm this mailing address is correct.</span>
    </label>
  </div>
);
